<h2 mat-dialog-title>Configurar producto</h2>

<mat-dialog-content>
  @if (!company_product_loaded()) {
    <div class="loading-wrapper">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  } @else {
    <p class="dialog-intro">Configura la facturación y la integración con Holded del producto.</p>

    <form [formGroup]="form" class="settings-form">
      <section class="form-section">
        <h3>Facturación</h3>

        <mat-form-field appearance="outline">
          <mat-label>Relación factura ↔ periodo trabajado</mat-label>
          <mat-select formControlName="invoice_relative_to_billed_period">
            @for (option of invoice_relative_options; track option.value) {
              <mat-option [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
          @if (form.controls.invoice_relative_to_billed_period.value; as selected) {
            <mat-hint>
              @for (option of invoice_relative_options; track option.value) {
                @if (option.value === selected) {
                  {{ option.description }}
                }
              }
            </mat-hint>
          }
        </mat-form-field>
      </section>

      <section class="form-section">
        <h3>Integración con Holded</h3>

        <mat-form-field appearance="outline">
          <mat-label>Cuenta contable del producto</mat-label>
          <input
            type="text"
            matInput
            [formControl]="holded_account_input"
            [matAutocomplete]="autoAccount"
            (blur)="onAccountInputBlur()"
            placeholder="Buscar por número o nombre"
          />
          <mat-autocomplete
            #autoAccount="matAutocomplete"
            [displayWith]="displayAccount"
            (optionSelected)="onAccountSelected($event.option.value)"
          >
            @if (chart_of_accounts_loading()) {
              <mat-option disabled>
                <span class="autocomplete-status">
                  <mat-spinner diameter="18"></mat-spinner>
                  <span>Cargando plan contable…</span>
                </span>
              </mat-option>
            } @else if (chart_of_accounts_empty()) {
              <mat-option disabled>Sin resultados</mat-option>
            } @else {
              @for (option of filtered_chart_of_accounts(); track option.account.id) {
                <mat-option [value]="option.account">{{ option.label }}</mat-option>
              }
            }
          </mat-autocomplete>
          <mat-hint>Las facturas con líneas asociadas a esta cuenta se asignan automáticamente al producto.</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Contacto Holded de la empresa</mat-label>
          <input
            type="text"
            matInput
            [formControl]="holded_contact_input"
            [matAutocomplete]="autoContact"
            (blur)="onContactInputBlur()"
            placeholder="Escribe al menos 2 caracteres"
          />
          <mat-autocomplete
            #autoContact="matAutocomplete"
            [displayWith]="displayContact"
            (optionSelected)="onContactSelected($event.option.value)"
          >
            @if (holded_contacts_loading()) {
              <mat-option disabled>
                <mat-spinner diameter="20"></mat-spinner>
              </mat-option>
            }
            @for (contact of holded_contacts_results(); track contact.id) {
              <mat-option [value]="contact">
                <div class="contact-option">
                  <span class="contact-name">{{ contact.name }}</span>
                  @if (contact.code) {
                    <span class="contact-code">{{ contact.code }}</span>
                  }
                </div>
              </mat-option>
            }
          </mat-autocomplete>
          <mat-hint>Este contacto se usa para sincronizar las facturas emitidas por Holded.</mat-hint>
        </mat-form-field>
      </section>
    </form>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()" [disabled]="saving()">Cancelar</button>
  <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="!company_product_loaded() || form.invalid || saving()">
    @if (saving()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      <ng-container>Guardar</ng-container>
    }
  </button>
</mat-dialog-actions>
